"use strict";

define('uikit/modules/token',['underscore', 'backbone', '../elements/label', '../extra/key.codes', '../helper/dom', '../templates'], function (_, Backbone, Label, KeyCodes, DOMHelper, Templates) {
  var TokenView = Label.extend({
    template: Templates.UIKit['token'],
    options: _.extend({}, Label.prototype.options, {
      single: true,
      editing: false,
      selected: false,
      separator: ':',
      icon: 'remove circle'
    }),
    update: _.extend({}, Label.prototype.update, {
      selected: false,
      separator: false,
      editing: false
    }),
    bindings: {
      text: 'text',
      title: 'title',
      detail: 'value'
    },
    ui: {
      text: '.text',
      detail: '.detail'
    },
    events: {
      'keydown': 'handleKeydown',
      'keyup @ui.detail': 'handleKeyupOnDetail',
      'keydown @ui.detail': 'handleKeydownOnDetail'
    },
    triggers: {
      'blur': 'deselect',
      'blur .detail': 'not:editing deselect complete',
      'focus': 'selected',
      'focus .detail': 'editing',
      'click .icon.remove.circle': 'close'
    },
    completeEdit: function completeEdit() {
      this.ui.detail.blur();
    },
    setCursorToStart: function setCursorToStart() {
      var el = this.ui.detail.get(0);
      DOMHelper.placeCaretAtStart(el);
    },
    setCursorToEnd: function setCursorToEnd() {
      var el = this.ui.detail.get(0);
      DOMHelper.placeCaretAtEnd(el);
    },
    setDetail: function setDetail(text) {
      if (this._cachedDetail == null) {
        this._cachedDetail = this.detail;
      }
      this.ui.detail.text(text);
      this._internal.detail = text;
      this.setCursorToEnd();
    },
    resetDetail: function resetDetail() {
      this.setDetail(this._cachedDetail || '');
      this._cachedDetail = null;
    },
    setFocus: function setFocus() {
      this.$el.focus();
      return this;
    },
    setFocusOnEdit: function setFocusOnEdit() {
      this.ui.detail.focus();
    },
    removeAllFocus: function removeAllFocus() {
      DOMHelper.clearSelection();
    },
    handleKeydown: function handleKeydown(ev) {
      if (this.el == ev.target) {
        if (ev.keyCode === KeyCodes.BACKSPACE_KEY || ev.keyCode === KeyCodes.DELETE_KEY) {
          ev.preventDefault();
          this.triggerMethod('close');
        }
      }
    },
    handleKeydownOnDetail: function handleKeydownOnDetail(ev) {
      var self = this,
        keyCode = ev.keyCode,
        cursorPos = DOMHelper.cursorPosition(),
        caretStart = cursorPos.caretStart,
        caretEnd = cursorPos.caretEnd,
        selLength = cursorPos.selectionLength,
        oldValue = ev.target.textContent;
      if (selLength) {
        ev.stopPropagation();
      }
      if (keyCode === KeyCodes.ENTER_KEY) {
        ev.preventDefault();
      } else if (keyCode === KeyCodes.TAB_KEY) {
        ev.stopPropagation();
      } else if (keyCode === KeyCodes.RIGHTARROW_KEY && caretStart !== this.detail.length) {
        ev.stopPropagation();
      } else if (keyCode === KeyCodes.LEFTARROW_KEY && caretStart !== 0) {
        ev.stopPropagation();
      } else if (keyCode === KeyCodes.DOWNARROW_KEY || keyCode == KeyCodes.UPARROW_KEY) {
        ev.preventDefault();
      } else if (keyCode === KeyCodes.BACKSPACE_KEY && caretStart == 0 && !selLength) {
        ev.preventDefault();
        this.removeAllFocus();
        this.setFocus();
      } else {
        _.defer(function () {
          if (oldValue !== ev.target.textContent) {
            self._cachedDetail = ev.target.textContent;
            self._internal.detail = ev.target.textContent;
            self.triggerMethod('value:edit', ev.target.textContent);
          }
        });
      }
    },
    handleKeyupOnDetail: function handleKeyupOnDetail(ev) {
      if (ev.keyCode === KeyCodes.ENTER_KEY) {
        this._internal.detail = ev.target.textContent;
      }
      this.triggerMethod('keypress', ev);
    },
    onRender: function onRender() {
      if (this.getBoolOption('single')) {} else {
        this.ui.detail.attr('contentEditable', 'true');
      }
    },
    onComplete: function onComplete() {
      this._cachedDetail = null;
    },
    updateAttributes: function updateAttributes() {
      Label.prototype.updateAttributes.apply(this, arguments);
      this.addClass('selected', this.getBoolOption('selected'));
      this.addClass('editing', this.getBoolOption('editing'));
      if (this.title) {
        this.$el.popup({
          variation: 'inverted',
          content: this.title
        });
      } else {
        this.$el.popup('destroy');
      }
      this.$el.attr('tabindex', -1);
    },
    onDestroy: function onDestroy() {
      this.$el.popup('destroy');
    }
  });
  return TokenView;
});

